import {
  Row,
  Col,
  Card,
  Button,
  Skeleton,
  Avatar,
  Image,
  Tag,
  Table,
  Collapse,
  Descriptions,
  Tabs,
  Timeline,
  Tooltip,
} from "antd";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import { ArrowLeftOutlined, PaperClipOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { TabPane } from "react-bootstrap";
const { Panel } = Collapse;

function View() {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const { request } = useRequest();

  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchData = () => {
    setLoading(true);
    request({
      url: `${apiPath.userViewDetail}/${id}`,
      method: "GET",
      onSuccess: (data) => {
        console.log("API data:", data);
        const responseData = data?.data;
        setUserData(responseData);
        setLoading(false);
      },
      onError: (error) => {
        ShowToast(error, "error");
      },
      onFinally: () => {
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const threadColumns = [
    {
      title: "Forum Name",
      dataIndex: "forum_name",
      key: "forum_name",
      render: (text) => text || "-",
    },
    {
      title: "Thread Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      render: (text) => (
        <Tooltip title={text}>
          <div
            style={{
              maxWidth: 250,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {text || "-"}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Comments",
      dataIndex: "comment_count",
      key: "comment_count",
    },
    {
      title: "Pinned",
      dataIndex: "is_pinned",
      key: "is_pinned",
      render: (value) => (
        <Tag color={value ? "green" : "red"}>{value ? "Yes" : "No"}</Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => moment(date).format("lll"),
    },
  ];

  return (
    <div className="main-view-page-super-main">
      <div className="float-left mb-2">
        <Button onClick={() => navigate(-1)} icon={<ArrowLeftOutlined />}>
          Back
        </Button>
      </div>

      <Card
        loading={loading}
        className="criclebox"
        bordered={false}
      >
        <div className="modal_header">
User Details
        </div>
        <Row gutter={[24, 24]}>
          <Col span={24} md={4}>
            {userData?.image ? (
              <Avatar shape="square" size={64} src={userData.image} />
            ) : (
              <Avatar shape="square" size={64}>
                {userData?.name?.charAt(0)}
              </Avatar>
            )}
          </Col>
          <Col span={24} md={24}>
            <Descriptions bordered column={1} labelStyle={{ fontWeight: 600 }}>
              <Descriptions.Item label="Name">
                {userData?.name || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {userData?.email || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="initial Credit">
                {userData?.initial_credit || "-"}
              </Descriptions.Item>
              {/* <Descriptions.Item label="Role">{userData?.roles || "-"}</Descriptions.Item> */}
              {/* <Descriptions.Item label="Phone">
                                {userData?.country_code && userData?.mobile_number
                                    ? `+${userData.country_code}-${userData.mobile_number}`
                                    : "-"}
                            </Descriptions.Item> */}
            </Descriptions>
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default View;
